$( function() {
    $( "#accordion-font" ).accordion({
      collapsible: true,
      active: false
    });
  } );

$( function() {
$( "#accordion-clips" ).accordion({collapsible: true, active: false});
});

$( ".style-header" ).click(function() {
  isActive = $(this).parent().accordion("option","active");
  if(isActive === false){
      $(this).children().last().children().last().css({"transform": "rotate(90deg)"});
      idChange = this.getAttribute("id");
      $("#"+idChange).css({"border-radius":"12px 12px 0px 0px"});
  }else{
      $(this).children().last().children().last().css({"transform": "rotate(0deg)"});
      idChange = this.getAttribute("id");
      $("#"+idChange).css({"border-radius":"12px 12px 12px 12px"});
      /*$(".ui-accordion-header").css({"border-radius":"12px 12px 12px 12px"});*/
  }
});


  $( ".clip" ).click(function() {
    $(".clip").css({"border":"2px solid white"});
    $(this).css({"border":"2px solid #ed4535"});
    value = $(this).attr("value");
    $("#clip-selected").html(" - "+"<strong>"+value+"</strong>");
    $("input#selected-clip").val(value);
    $("#accordion-clips").accordion({active: false});
    $("#accordion-clips").children().first().children().children().last().css({"transform": "rotate(0deg)"});
  });

  $( ".fonts" ).click(function() {
    $(".fonts").css({"border":"2px solid white"});
    $(this).css({"border":"2px solid #ed4535"});
    font_value = $(this).attr("value");
    font_name = font_value.split(" - ")[1];
    $("#font-selected").html(" - "+"<strong>"+font_name+"</strong>");
    $("input#selected-font").val(font_value);
    $("#accordion-font").accordion({active: false});
    $("#accordion-font").children().first().children().children().last().css({"transform": "rotate(0deg)"});
  });

/*
add somewhere the behavior of the input fields, like the below:

TODO:
- put the placeholder of the input box
- hide the relative label for the input box
- see if there is a way to make the ease of "show()" a little smoother

$("input#numero-pupperino").click(function(){
  $('label[for="numero-pupperino"]').show();
    $("input#numero-pupperino").attr("placeholder","");
})

 */